import { Component, OnDestroy, OnInit } from '@angular/core';
import { uiHelper } from '~/helpers/ui.helper';
import { translationHelper } from '~/helpers/translation.helper';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { CoreService } from '~/legacy/ts/services/core.service';
import { Subscription } from 'rxjs';
declare let $;

@Component({
    selector: 'comp_transactions_modal',
    templateUrl: './transactions-modal.html',
})
export class TransactionsModal implements OnInit, OnDestroy {
    transactionsSubscription: Subscription;
    bookingsList = [];
    Balance;
    Bonus;
    Deposit;
    LostAmount;
    OpenCount;
    TotalBet;
    WinAmount;
    Withdraw;
    selectedTransType = 0;
    constructor(
        private _uiHelper: uiHelper,
        public translate: translationHelper,
        public tournamentsService: TournamentsService,
        public coreService: CoreService,
    ) {
        // this.getBookings();
        this.transactionsSubscription = this._uiHelper.transactionModalListener.subscribe((x: any) => {
            if (x) {
                // console.log('CUSTOMER_ID', this.coreService.customerUser.CustomerId);
                this.getBookings();
            } else {
                this.bookingsList = [];
                this.Balance = 0;
                this.Bonus = 0;
                this.Deposit = 0;
                this.LostAmount = 0;
                this.OpenCount = 0;
                this.TotalBet = 0;
                this.WinAmount = 0;
                this.Withdraw = 0;
            }
        });
    }

    ngOnInit() {}

    ngAfterViewInit() {}

    modalHide() {
        $('#Transactions_Modal').modal('hide');
    }

    ngOnDestroy() {
        if (this.transactionsSubscription != undefined) {
            this.transactionsSubscription.unsubscribe();
        }
    }

    getBookings() {
        //console.warn("getBookings");
        let today = new Date();
        let defaultMonth = today.getMonth();
        let defaultYear = today.getFullYear();
        this.tournamentsService
            .getBookings(defaultMonth, defaultYear, this.selectedTransType, this.coreService.customerUser.CustomerId)
            .then(x => {
                //console.warn("getBookings",x);
                this.bookingsList = x;
                this.bookingLoginResult();
            });
    }

    bookingLoginResult() {
        console.log('bookingLoginResult');
        this.tournamentsService.bookingLoginResult(this.coreService.customerUser.QrCustomerId).then((x: any) => {
            this.Balance = x[0].Balance;
            this.Bonus = x[0].Bonus;
            this.Deposit = x[0].Deposit;
            this.LostAmount = x[0].LostAmount;
            this.OpenCount = x[0].OpenCount;
            this.TotalBet = x[0].TotalBet;
            this.WinAmount = x[0].WinAmount;
            this.Withdraw = x[0].Withdraw;
        });
    }
}
